import React, { useState } from 'react';
import { useAuth } from '../AuthProvider';
import './Pricing.css';

const Pricing = () => {
  const { user } = useAuth();
  const [promotionCode, setPromotionCode] = useState('');
  const [message, setMessage] = useState('');
  const [failedAttempts, setFailedAttempts] = useState(0);

  const handleCheckout = async () => {
    const response = await fetch('/create-checkout-session', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${await user.getIdToken()}`,
      },
    });
    const session = await response.json();
    if (session.error) {
      console.error(session.error.message);
    }
  };

  const handlePromotion = async () => {
    try {
      const response = await fetch('/apply-promotion', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${await user.getIdToken()}`,
        },
        body: JSON.stringify({ promotionCode }),
      });
      const data = await response.json();
      if (data.success) {
        setMessage(data.message);
      } else {
        setFailedAttempts(prev => prev + 1);
        if (failedAttempts >= 9) {
          setMessage('Too many failed attempts. Please contact support for assistance.');
        } else {
          setMessage(data.error || 'Invalid promotion code. Please try again.');
        }
      }
    } catch (error) {
      console.error('Error applying promotion code:', error);
      setMessage('Failed to apply promotion code. Please try again later.');
    }
  };

  return (
    <div className="pricing-container">
      <h1>Pricing Plans</h1>
      <div className="pricing-plans">
        <div className="pricing-plan">
          <h2>Free Plan</h2>
          <p className="price">$0/month</p>
          <ul>
            <li>1 mock interview</li>
            <li>Basic feedback</li>
            <li>Limited question bank</li>
          </ul>
          <button className="plan-button">Current Plan</button>
        </div>
        <div className="pricing-plan featured">
          <h2>Pro Plan</h2>
          <p className="price">$1/month</p>
          <ul>
            <li>Unlimited mock interviews</li>
            <li>Detailed AI-powered feedback</li>
            <li>Full access to question bank</li>
            <li>Priority support</li>
          </ul>
          <button className="plan-button" onClick={handleCheckout}>Upgrade to Pro</button>
        </div>
      </div>
      {failedAttempts < 10 ? (
        <div className="promotion-section">
          <h3>Have a promo code?</h3>
          <input
            type="text"
            placeholder="Enter promotion code"
            value={promotionCode}
            onChange={(e) => setPromotionCode(e.target.value)}
          />
          <button onClick={handlePromotion}>Apply Promotion</button>
        </div>
      ) : null}
      {message && <p className="message">{message}</p>}
    </div>
  );
};

export default Pricing;